import {
  DashboardOutlined,
  NotificationOutlined,
  ThunderboltOutlined,
  ProfileOutlined,
  SettingOutlined,
  UserOutlined,
  SolutionOutlined
} from '@ant-design/icons';
import { routes } from './routes';

export const listMenuSider = [
  {
    key: routes.home,
    icon: <DashboardOutlined />,
    label: 'Tổng quan'
  },
  {
    key: routes.matches,
    icon: <NotificationOutlined />,
    label: 'Quản lý trận đấu'
  },
  {
    key: routes.prediction,
    icon: <ThunderboltOutlined />,
    label: 'Quản lý dự đoán'
  },
  {
    key: routes.predictionResult,
    icon: <ProfileOutlined />,
    label: 'Kết quả dự đoán'
  },
  {
    key: routes.settings,
    icon: <SettingOutlined />,
    label: 'Cài đặt'
  },
  {
    key: routes.users,
    icon: <UserOutlined />,
    label: 'Quản lý người dùng'  
  },
  {
    key: routes.whitelist,
    icon: <SolutionOutlined />,
    label: 'IP Whitelist'
  }
];

export const pRoute = {
  [routes.home]: routes.home,
  [routes.matches]: routes.matches,
  [routes.prediction]: routes.prediction,
  [routes.predictionResult]: routes.predictionResult,
  [routes.settings]: routes.settings,
  [routes.whitelist]: routes.whitelist
};

export const pOpenKeys = {
  [routes.companies]: 'companies',
  [routes.departments]: 'companies',
  [routes.groups]: 'companies'
};
